import { get, post } from './fetch'

export const getPlans = (categoryID) => {
    return get(`/api/subscription/category/${categoryID}/plans`, false);
}

export const getActiveSubscriptions = () => {
    return get(`/api/seller/subscription/active`, true);
}

export const getActiveSubscriptionsCount = () => {
    return get(`/api/seller/subscription/active/count`, true);
}

export const getInActiveSubscriptions = () => {
    return get(`/api/seller/subscription/in-active`, true);
}

export const getFailedPayments = (subsID) => {
    return get(`/api/seller/subscription/${subsID}/failed-payments`, true);
}

export const updateExistingPlanPayment = (reqParams) => {
    return post(`/api/seller/subscription/plan/payment`, reqParams, true);
}

export const getPlan = (planID) => {
    return get(`/api/subscription/plan/${planID}`, false);
}